import { connect } from 'react-redux';

import {
  ADD_IMAGES_TO_ROOMS,
  DELETE_ROOM_IMAGES,
  DELETE_ROOM_VIDEO,
  GET_ROOM_IMAGES,
  CHANGE_POSITION_ROOM_IMAGES,
  UPDATE_ROOM_IMAGES,
  GET_ROOM_NAMES,
  SET_ROOM_PREVIEW_IMAGE,
  UPDATE_ROOM_VIDEO,
} from 'store/room/actionTypes';
import { UPLOAD_MULTIPLE_MEDIA, UPLOAD_VIDEO } from 'store/media/actionTypes';

import SectionRoomPictureList from './SectionRoomPictureList';

const mapStateToProps = (state) => ({
  roomNames: state.Room.roomNames,

  isLoadingSetRoomPreviewImage: state.Room.isLoadingSetRoomPreviewImage,
  isLoadingAddImagesToRooms: state.Room.isLoadingAddImagesToRooms,
  isChangePositionRoomImages: state.Room.isChangePositionRoomImages,
  isLoadingDeleteRoomImages: state.Room.isLoadingDeleteRoomImages,
  isLoadingUpdateRoomVideo: state.Room.isLoadingUpdateRoomVideo,
  isLoadingDeleteRoomVideo: state.Room.isLoadingDeleteRoomVideo,
  isLoadingUploadMultipleMedia: state.Media.isLoadingUploadMultipleMedia,
  isLoadingUploadVideo: state.Media.loadingUploadVideo,
});

const mapDispatchToProps = (dispatch) => ({
  actionSetRoomPreviewImage: (payload) => dispatch({
    type: SET_ROOM_PREVIEW_IMAGE,
    payload,
  }),

  actionUploadMultiMedia: (payload) => dispatch({
    type: UPLOAD_MULTIPLE_MEDIA,
    payload,
  }),

  actionUploadVideo: (payload) => dispatch({
    type: UPLOAD_VIDEO,
    payload,
  }),

  actionAddImagesToRooms: (payload) => dispatch({
    type: ADD_IMAGES_TO_ROOMS,
    payload,
  }),

  actionUpdateRoomVideo: (payload) => dispatch({
    type: UPDATE_ROOM_VIDEO,
    payload,
  }),

  actionDeleteRoomVideo: (payload) => dispatch({
    type: DELETE_ROOM_VIDEO,
    payload,
  }),

  actionGetPlaceImages: (payload) => dispatch({
    type: GET_ROOM_IMAGES,
    payload,
  }),

  actionDeleteRoomImages: (payload) => dispatch({
    type: DELETE_ROOM_IMAGES,
    payload,
  }),

  actionChangePositionRoomImages: (payload) => {
    dispatch({
      type: CHANGE_POSITION_ROOM_IMAGES,
      payload,
    });
  },

  onUpdateRoomImageList: (payload) => {
    dispatch({
      type: UPDATE_ROOM_IMAGES,
      payload,
    });
  },

  actionGetRoomNamesSetting: (payload) => dispatch({
    type: GET_ROOM_NAMES,
    payload,
  }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SectionRoomPictureList);
